import { Controller } from "@hotwired/stimulus"

// Points a blocking message at the block that resolves it: it asks the
// disclosure carrying the given id to open itself and scroll into view. It goes
// over a window event rather than reaching into that element directly, because
// the block may be collapsed and only its own controller knows how to open it.
export default class extends Controller {
  static values = { target: String }

  open(event) {
    event.preventDefault()
    window.dispatchEvent(
      new CustomEvent("cup:disclosure-open", { detail: { id: this.targetValue } })
    )
  }
}
